import styled from 'styled-components';

export const Container = styled.div`
  left: calc(50% - 16px);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-items: center;
  display: flex;
  justify-content: center;
  background: ${(props) => (props.theme.simulation.sliderGroupBackgroundColor)};
`;
